export interface IModalLocales {
    [title: string]: {
        title: string;
        message: string;
    }
}

export interface IButtonLocales {
    [title: string]: {
        title: string;
        label: string;
    }
}

export interface ILabelLocales {
    [title: string]: string
}

export const ModalLocales: IModalLocales = {
    MarkForDeletion: {
        title: 'Confirm Mark For Deletion',
        message: 'Are you sure you want to mark this account for deletion?'
    },
    UnmarkForDeletion: {
        title: 'Confirm Unmark For Deletion',
        message: 'Are you sure you want to unmark this account for deletion? This will make the account ACTIVE|IN_PROGRESS so please make sure if account should be SUSPENDED'
    },
    SuspendAccount: {
        title: 'Confirm Suspend Account',
        message: 'Are you sure you want to suspend this account?'
    },
    UnsuspendAccount: {
        title: 'Confirm Unsuspend Account',
        message: 'Are you sure you want to unsuspend this account?'
    }
};

export const ButtonLocales: IButtonLocales = {
    Unsuspend: {
        label: 'UNSUSPEND',
        title: 'Only possible for suspended customers.'
    },
    Suspend: {
        label: 'SUSPEND',
        title: 'Only possible for approved customers that are not on a Ride.'
    },
    MarkForDeletion: {
        label: 'MARK FOR DELETION',
        title: 'Only possible for customers that are not still MARKED_FOR_DELETION.'
    },
    UnmarkForDeletion: {
        label: 'UNMARK FOR DELETION',
        title: 'Only possible for customers who are marked for deletion.'
    }
};